/** @format */

import React, { useState } from "react";
import { ReactComponent as Trash } from "bootstrap-icons/icons/trash.svg";
import { useTranslation } from "react-i18next";
import { Button, Modal, Spinner } from "react-bootstrap";
import { ResourceReference, UserResourceReference } from "../../../types";
import HelpLink from "../../helpLink/HelpLink";
import {
  useDeleteResourceMutation,
  useGetResourceClonesQuery,
} from "../../../app/services/resourcesApi";

type Props = {
  resource: ResourceReference | UserResourceReference;
};

const DeleteResource: React.FC<Props> = ({ resource }) => {
  const { t: _ } = useTranslation();

  const [showModal, setShowModal] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { data: clones, isLoading: isLoadingClones } =
    useGetResourceClonesQuery(resource.Code);

  const [deleteResource] = useDeleteResourceMutation();

  const removeResource = async () => {
    await deleteResource(resource.Code);
    setIsLoading(false);
  };

  return (
    <>
      <button
        title={_("deleteResource.btn")}
        className="action"
        onClick={() => setShowModal(true)}
      >
        <Trash className="icon" />
      </button>
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        aria-label="delete-user-resource-modal"
        centered
      >
        <Modal.Header closeButton>
          <span className="flex-grow-1">{_("deleteResource.header")}</span>
          <HelpLink position="inherit" className="p-0 help-link" />
        </Modal.Header>
        {isLoadingClones ? (
          <Spinner />
        ) : (
          <Modal.Body>
            <p>
              {_("deleteResource.clones", {
                clones:
                  (clones?.enCopies.length ?? 0) +
                  (clones?.cyCopies.length ?? 0),
              })}
            </p>
            <p>{_("deleteResource.checkMsg")}</p>
            <div className="d-flex gap-3 justify-content-end">
              <Button
                role="button"
                variant="outline-editing"
                onClick={() => setShowModal(false)}
              >
                {_("deleteResource.cancel")}
              </Button>
              <Button
                disabled={isLoading}
                role="button"
                variant="danger"
                onClick={async () => {
                  setIsLoading(true);
                  await removeResource();
                  setShowModal(false);
                }}
              >
                {isLoading ? <Spinner /> : _("deleteResource.delete")}
              </Button>
            </div>
          </Modal.Body>
        )}
      </Modal>
    </>
  );
};

export default DeleteResource;
